// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1GBMd","title":"Info_title__1K5ls","links":"Info_links__1HZMV","link":"Info_link__U5rWD","logo":"Info_logo__1l5J8"};